var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "  "
  }, /*#__PURE__*/React.createElement("g", {
    id: "  _2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 17.5001L13.7616 13.7551L17.5 17.5001ZM15.8333 8.75008C15.8333 10.6287 15.087 12.4304 13.7586 13.7588C12.4303 15.0871 10.6286 15.8334 8.74996 15.8334C6.87134 15.8334 5.06967 15.0871 3.74129 13.7588C2.4129 12.4304 1.66663 10.6287 1.66663 8.75008C1.66663 6.87146 2.4129 5.06979 3.74129 3.74141C5.06967 2.41303 6.87134 1.66675 8.74996 1.66675C10.6286 1.66675 12.4303 2.41303 13.7586 3.74141C15.087 5.06979 15.8333 6.87146 15.8333 8.75008V8.75008Z",
    stroke: "#9DB6EF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5571f863346a54a2b83dab725e484ca1.svg";
export { ForwardRef as ReactComponent };